import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref, watch} from "vue";
import {useDewasGajiListModel} from "@/stores/models/dewas-gaji-list-model";

export const useDewasGajiListStore  = defineStore(
    'dewasGajiListStore',
    () => {
        const gajiPeriodeId = ref(null);

        const isLoading = ref(false);
        const dataSourceDewasGajiList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useDewasGajiListModel().dewasGajiListCustomStore,
                filter: null,
                sort: null,
            })
        );

        const dataSourceDewasGajiDewasList = ref(null);
        const dataSourceDewasGajiSekreList = ref(null);
      

 
        const dataSourceDewasGajiDewasHistory = ref(
            new DataSource({
                requireTotalCount: true,
                store: useDewasGajiListModel().dewasGajiListCustomStore,
                filter: ['dewas_is_dewas', '=', true],  // Updated value
            })
        );

        const dataSourceDewasGajiSekreHistory = ref(
            new DataSource({
                requireTotalCount: true,
                store: useDewasGajiListModel().dewasGajiListCustomStore,
                filter: ['dewas_is_dewas', '=', false],  // Updated value
              
            })
        );

        // Watch gajiPeriodeId and update dataSourceGajiDireksiList when it changes
        watch(
            gajiPeriodeId,
            (newValue) => {
                // Reinitialize the DataSource when gajiPeriodeId changes
                dataSourceDewasGajiDewasList.value = new DataSource({
                    requireTotalCount: true,
                    store: useDewasGajiListModel().dewasGajiListCustomStore,
                    filter: [['dewas_is_dewas', '=', true], 'and', ['gaji_periode_id', '=', newValue]],  // Updated value
                   
                });
                dataSourceDewasGajiSekreList.value = new DataSource({
                    requireTotalCount: true,
                    store: useDewasGajiListModel().dewasGajiListCustomStore,
                    // filter: [[['gajis_pegawai_status_id', '=', 2], 'or', ['gajis_pegawai_status_id', '=', 3]], 'and', ['gaji_periode_id', '=', newValue]]  // Updated value
                    filter: [['dewas_is_dewas', '=', false], 'and', ['gaji_periode_id', '=', newValue]],  // Updated value
                });
            },
            { immediate: true }  // Ensure it runs immediately when the component is set up
        );


        const setGajiPeriodeId = (data) => {
            
            gajiPeriodeId.value = data;
          };
       
        const loadData = async (filter = null, sort=null) => {
            isLoading.value = true;
            try {
                dataSourceDewasGajiList.value.filter(filter);
                dataSourceDewasGajiList.value.sort(sort);
                // Reload the DataSource with the new filter
                const result = await dataSourceDewasGajiList.value.load();
                return result;
            } catch (error) {
                console.error("Error loading data:", error);
                throw error;
            } finally {
                isLoading.value = false;
            }
        };

        const insertData = async (newItem) => {
           
            try {
                const result = await dataSourceDewasGajiList.value.store().insert(newItem);


                return result;
            } catch (error) {
                console.error("Error inserting data:", error);
                throw error;
            }
        };

        const updateData = async (updatedRows) => {
            
            const store = dataSourceDewasGajiList.value.store();
            try {
                // Create an array of update promises
                const updatePromises = updatedRows.map(row => {
                  return store.update(row.id, row); // Assume `id` is the key field
                });
          
                // Wait for all update operations to complete
               
                const results = await Promise.all(updatePromises);
          
                return results;
              } catch (error) {
                console.error("Error updating data:", error);
                throw error;
              }
        };


        



        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourceDewasGajiList.value.reload();
        };

     

        const initialized = ()=>{     
            dataSourceDewasGajiList.value.reload();
        };

        return {
           loadData,
           insertData,
           updateData,
            dataSourceDewasGajiList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state,
            dataSourceDewasGajiDewasList,
            dataSourceDewasGajiSekreList,
            dataSourceDewasGajiDewasHistory,
            dataSourceDewasGajiSekreHistory,
            setGajiPeriodeId,
        }
    }
);